import { actionTypes } from "../actionTypes/actionTypes";
import { InterventionReducerState } from "../../interfaces/store/interventionReducerState";
import { ADMIN } from "../../constants/admin";

const initialState: InterventionReducerState = {
  id: null,
  fetchTranscribeId: null,
  interventionFormOpen: false,
  interventionTableData: [],
  interventionFormType: ADMIN.MEETING_FORM_TYPE.CREATE,
  interventionSelectedRowData: null,
  fetchIntervenlabel: false,
};

const interventionReducer = (
  state: InterventionReducerState = initialState,
  action: any
) => {
  switch (action.type) {
    case actionTypes.OPEN_INTERVENTION_FORM:
      return {
        ...state,
        interventionFormOpen: action.payload,
      };
    case actionTypes.UPDATE_INTERVENTION_TABLE_DATA:
      return {
        ...state,
        interventionTableData: action.payload,
      };
    case actionTypes.SELECTED_INTERVENTION_TABLE_ROW:
      return {
        ...state,
        interventionSelectedRowData: action.payload,
      };
    case actionTypes.UPDATE_INTERVENTION_FORM_TYPE:
      return {
        ...state,
        interventionFormType: action.payload,
      };
    case actionTypes.UPDATE_FETCH_INTERVENTION_LABEL:
      return {
        ...state,
        fetchIntervenlabel: action.payload,
      };

    default:
      return state;
  }
};

export default interventionReducer;
